export default "__VITE_ASSET__CJVRJVIu__"